import '../tracking/events.quiz-bank';
import { useImpressionRef } from '@zep/logger/react';
import { trackEvent } from '@zep/logger/tracking';
import { useIsLoggerUserInfoSet } from '@/lib/auth/UserContext';
import { MAX_QUIZ_COUNT } from '@/views/build/constant';
import { useShowQuizBankModal } from '../hooks';
import { QuizBankEntryRowUI } from './QuizBankEntryRowUI';
interface TrackedRowProps {
  isFull: boolean;
  remainingSlots: number;
  onOpen: () => void;
}

/*
  베타 진입점 발견율의 분모. 이 행은 초등·수학에서만 렌더되므로 노출 자체가
  "지원 조합에 도달했다"는 뜻이고, 상한에 닿아 누를 수 없는 노출도 함께 센다.
  마운트가 아니라 **보일 때** 1회 — 문항 리스트 아래로 밀려 화면 밖에 있을 수 있다.

  관측을 시작하는 컴포넌트를 따로 둔 이유: `useImpressionRef` 는 첫 교차에서 발화
  완료로 표시해 다시 쏘지 않는다. React 는 자식 이펙트를 부모(`UserProvider`)보다
  먼저 돌리므로, 게이트 없이 관측을 걸면 이 분모만 사용자·플랜 문맥 없이 저장된다.
*/
const TrackedQuizBankEntryRow = ({
  isFull,
  remainingSlots,
  onOpen
}: TrackedRowProps) => {
  const impressionRef = useImpressionRef<HTMLDivElement>(() => trackEvent('quiz_bank_entry_row_view', {
    place: 'build_entry_row',
    is_full: isFull,
    remaining_slot_count: remainingSlots
  }));
  return <QuizBankEntryRowUI rootRef={impressionRef} isFull={isFull} limit={MAX_QUIZ_COUNT} onOpen={onOpen} data-sentry-element="QuizBankEntryRowUI" data-sentry-component="TrackedQuizBankEntryRow" data-sentry-source-file="QuizBankEntryRow.tsx" />;
};

/** 빌드 편집 화면의 문제 은행 재진입 진입점. 초등·수학이 아니면 렌더하지 않는다. */
export const QuizBankEntryRow = () => {
  const {
    isSupported,
    remainingSlots,
    open
  } = useShowQuizBankModal();
  const isLoggerUserInfoSet = useIsLoggerUserInfoSet();
  if (!isSupported) return null;
  const isFull = remainingSlots === 0;

  // 문맥이 실리기 전에도 행은 정상적으로 보여 준다 — 늦추는 것은 관측뿐이다.
  if (!isLoggerUserInfoSet) {
    return <QuizBankEntryRowUI isFull={isFull} limit={MAX_QUIZ_COUNT} onOpen={open} />;
  }
  return <TrackedQuizBankEntryRow isFull={isFull} remainingSlots={remainingSlots} onOpen={open} data-sentry-element="TrackedQuizBankEntryRow" data-sentry-component="QuizBankEntryRow" data-sentry-source-file="QuizBankEntryRow.tsx" />;
};